<div class="ptm-modal">

  <!-- Header -->
  <div class="ptm-header">
    <h5 class="ptm-title">
      <i class="pi pi-print"></i>
      Print Template
    </h5>
    <button type="button" class="ptm-close" (click)="cancel()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="ptm-body">
    <p class="ptm-desc">Select a template to use for this printout. The global default is pre-selected.</p>

    <div class="ptm-loading" *ngIf="loading">
      <p-progressSpinner [style]="{width: '32px', height: '32px'}"></p-progressSpinner>
    </div>

    <div class="ptm-empty" *ngIf="!loading && templates.length === 0">
      <i class="pi pi-exclamation-triangle"></i>
      <p>No templates available. Please create a template in the Receipt Template Designer.</p>
    </div>

    <div class="ptm-list" *ngIf="!loading && templates.length > 0">
      <div
        *ngFor="let template of templates"
        class="ptm-item"
        [class.ptm-item--selected]="selectedTemplate?.id === template.id"
        (click)="selectTemplate(template)">

        <div class="ptm-item__radio">
          <div class="ptm-radio-dot" [class.active]="selectedTemplate?.id === template.id"></div>
        </div>

        <div class="ptm-item__info">
          <div class="ptm-item__name">
            {{ template.name }}
            <span class="ptm-default-badge" *ngIf="template.isGlobalDefault">Default</span>
          </div>
          <div class="ptm-item__meta">
            {{ template.widthMm }} × {{ template.heightMm }} mm &nbsp;·&nbsp; {{ template.elements.length }} element(s)
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="ptm-footer">
    <button pButton label="Cancel" class="p-button-text" (click)="cancel()"></button>
    <button pButton icon="pi pi-print" label="Print" class="p-button-primary"
      [disabled]="!selectedTemplate" (click)="print()">
    </button>
  </div>

</div>
